import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

/** „+ Нова резервация" — 36px, колкото денят и табовете на регионите. */
const NewReservationButton = ({
  onClick,
  className = "",
}: {
  onClick: () => void;
  className?: string;
}) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      title={t("reservations.newReservation")}
      aria-label={t("reservations.newReservation")}
      className={`flex h-9 shrink-0 cursor-pointer items-center justify-center gap-1.5 rounded-[10px] border-none bg-brand text-[13px] font-bold text-white shadow-[0_1px_2px_rgba(28,25,23,0.12)] transition-colors duration-150 hover:bg-brand-deep px-4 ${className}`}
    >
      <PlusOutlined className="text-[12px]" />
      <span>{t("reservations.newReservation")}</span>
    </button>
  );
};

export default NewReservationButton;
